import { render, staticRenderFns } from "./BuKundenHerstellerUmsaetze.vue?vue&type=template&id=2e1c3e73&"
import script from "./BuKundenHerstellerUmsaetze.vue?vue&type=script&lang=js&"
export * from "./BuKundenHerstellerUmsaetze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports